import { Link } from "react-router-dom";
import { ArrowLeft, Hammer } from "lucide-react";

// Professional placeholder for GR CONNECT roadmap modules. No fake data, no local storage —
// the module activates once the attendance backend exposes its APIs in a later phase.
const ModulePending = ({ icon: Icon, title, blurb }) => (
  <div className="max-w-2xl mx-auto" data-testid={`module-pending-${(title || "").toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
    <div className="bg-white border border-slate-200 p-10 lg:p-14 text-center">
      <span className="mx-auto w-16 h-16 bg-[#0A1128] flex items-center justify-center">
        {Icon ? <Icon size={26} className="text-[#E8574F]" /> : <Hammer size={26} className="text-[#E8574F]" />}
      </span>
      <p className="mt-6 inline-block border border-amber-300 bg-amber-50 text-amber-700 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.25em]" data-testid="module-pending-badge">
        Module Setup Pending
      </p>
      <h1 className="mt-4 font-display text-2xl font-bold text-slate-900" data-testid="module-pending-title">{title}</h1>
      <p className="mt-3 text-sm text-slate-500 leading-relaxed max-w-md mx-auto">
        {blurb || "This GR CONNECT module is on the roadmap and will be activated in a later phase. No data is stored here yet — the employee master, login and permissions remain in the central attendance system."}
      </p>
      <Link to="/app" data-testid="module-pending-back"
        className="mt-8 inline-flex items-center gap-2 border border-[#0A1128] text-[#0A1128] hover:bg-slate-50 px-5 py-2.5 text-xs font-display font-semibold uppercase tracking-widest rounded-sm transition-colors">
        <ArrowLeft size={13} /> Back to Dashboard
      </Link>
    </div>
  </div>
);

export default ModulePending;
